import React from 'react';


import SideBar from './SideBar';
import MainWrapper from "./MainWrapper";


function Layout({Component}) {
 
  return (
    <>
      <div
        className="page-wrapper"
        id="main-wrapper"
        data-layout="vertical"
        data-navbarbg="skin6"
        data-sidebartype="full"
        data-sidebar-position="fixed"
        data-header-position="fixed"
      >
        <SideBar/>
        <MainWrapper Component={Component}/>
        
      </div>
    </>
  );
}

export default Layout;
